'use client';
import NotFoundPageShell from '../components/NotFoundPageShell';

/**
 * Displays 404 page.
 */
const NotFoundPage = () => <NotFoundPageShell />;

export default NotFoundPage;
